<div class="filter-interval">
  <div class="filter-interval__from vox-input-group vox-input-group_dense">
    <input
      type="text"
      [value]="value.from || ''"
      (input)="onChangeFromValue($event)"
      placeholder="1"
      class="vox-text-field" />
    <div class="filter-interval__separator">
      <span>{{ "events.company-call-history.filters.and" | Translate }}</span>
    </div>
  </div>
  <div class="filter-interval__to vox-input-group vox-input-group_dense">
    <input
      type="text"
      [value]="value.to || ''"
      (input)="onChangeToValue($event)"
      placeholder="30"
      class="vox-text-field" />
    <div
      class="filter-interval__unit"
      *ngIf="unit">
      <span>{{ "events.company-call-history.filters.units." + unit | Translate }}</span>
    </div>
  </div>
</div>
